import * as React from "react";

interface State {
  timeUpdateWasRequested: number; // unix time
}

const listeners: Array<(state: State) => void> = [];

let memoryState: State = { timeUpdateWasRequested: 0 };

function dispatch({ timeUpdateWasRequested }: State) {
  if (timeUpdateWasRequested > 0) {
    memoryState = { timeUpdateWasRequested };
    listeners.forEach((listener) => {
      listener(memoryState);
    });
  }
}

function updateTime({ timeUpdateWasRequested }: State) {
  dispatch({
    timeUpdateWasRequested,
  });

  return;
}

function useNotificationsUpdater() {
  const [state, setState] = React.useState<State>(memoryState);

  React.useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);

  return {
    ...state,
    updateTime,
  };
}

export { useNotificationsUpdater };
